import { render, staticRenderFns } from "./changes-history.vue?vue&type=template&id=e07d4136"
import script from "./changes-history.vue?vue&type=script&lang=js"
export * from "./changes-history.vue?vue&type=script&lang=js"
import style0 from "./changes-history.vue?vue&type=style&index=0&id=e07d4136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports